$(function () {
    $('.upbtn').click(
        function () {
            $('html,body').animate({ scrollTop: '0px' }, 800);
        }
    );
});


// WEBPACK FOOTER //
// ./share/client/js/scrolltop.js